import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map, List } from 'immutable';

import BasicCreateButton from '../../../components/buttons/BasicCreateButton/';
import DropdownBox from '../../../components/inputs/DropdownBox';
import RelationshipTypeCard from '../../../components/cards/RelationshipTypeCard';

import { RelationshipTypeActions } from '../../../actions/relationshipType';
import { ModalActions } from '../../../actions/modal';
import { ProjectActions } from '../../../actions/project';

class RelationshipTypes extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    relationshipTypes: PropTypes.instanceOf(Map),
    icons: PropTypes.instanceOf(Map),
  }

  confirmDelete = (relationshipTypeId) => {
    const { dispatch, relationshipTypes } = this.props;

    const relationshipTypeToDelete = relationshipTypes.get(relationshipTypeId);

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'relationshipType',
        handleDelete: this.handleDelete.bind(this, relationshipTypeToDelete),
        name: relationshipTypeToDelete.get('type'),
      },
    }));
  }

  handleDelete = (relationshipType) => {
    const { dispatch, currentProjectId } = this.props;
    const relationshipTypeId = relationshipType.get('id');

    dispatch(RelationshipTypeActions.deleteRelationshipType({
      relationshipTypeId,
      currentProjectId,
    }));
  }

  toggleModal = () => {
    const { dispatch } = this.props;
    dispatch(ModalActions.toggleModal({
      name: 'CreateRelationshipTypeModal',
    }));
  }

  sortData = (filterType) => {
    const { dispatch } = this.props;

    dispatch(ProjectActions.sortData('relTypes', filterType));
  }

  renderRelationshipTypes = () => {
    const { currentProjectId, icons, relationshipTypes } = this.props;

    return relationshipTypes.reduce((prev, relType) => {
      const relTypeOverride = relType.get('type') === 'Work Breakdown Structure' ? relType.set('type', 'WBS') : relType;
      return prev.push(
        <RelationshipTypeCard
          key={relType}
          projectId={currentProjectId}
          relationshipType={relTypeOverride}
          onDelete={this.confirmDelete}
          icons={icons}
        />
      );
    }, List());
  }

  render() {
    const { sort } = this.props;

    return (
      <div className="row tab-content-wrapper">
        <div className="col-md-12 project-default-left-col">
          <h2>Relationship Types</h2>
          <BasicCreateButton
            className="btn btn-primary btn-sm"
            onClick={this.toggleModal}
          >
            <i className="fa fa-plus"></i> New Relationship Type
          </BasicCreateButton>
          <DropdownBox
            onClick={this.sortData}
            selectedSort={sort}
            dropdownOptions={
              [{
                label: 'A ➙ Z',
                labelKey: 'ascending',
              }, {
                label: 'Z ➙ A',
                labelKey: 'descending',
              }, {
                label: 'Newest First',
                labelKey: 'date',
              }]
            }
          />
          <div className="row">
            {this.renderRelationshipTypes()}
          </div>
        </div>
      </div>
    );
  }
}

export default RelationshipTypes;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/RelationshipTypes/RelationshipTypes.js